module.exports = __webpack_public_path__ + "img/9788989571568.68a17d83.jpg";